import { apiRequest } from '@/services/http'
import type {
  CenterCountryDetail,
  CenterCountryListItem,
  CenterCountryOption,
  CenterCountryPageParams,
  CenterCountrySaveRequest,
  CenterCountryImageUpdateRequest,
  CenterCurrencyDetail,
  CenterCurrencyListItem,
  CenterCurrencyOption,
  CenterCurrencyPageParams,
  CenterCurrencySaveRequest,
  CenterExchangeRateDetail,
  CenterExchangeRateListItem,
  CenterExchangeRatePageParams,
  CenterExchangeRateSaveRequest,
  CenterId,
  CenterLanguageDetail,
  CenterLanguageListItem,
  CenterLanguageOption,
  CenterLanguagePageParams,
  CenterLanguageSaveRequest,
  CenterPageResult,
  CenterTimezoneOption
} from '@/types/businessCenter'

const COUNTRIES_URL = '/admin/center/config/countries'
const CURRENCIES_URL = '/admin/center/config/currencies'
const EXCHANGE_RATES_URL = '/admin/center/config/exchange-rates'
const LANGUAGES_URL = '/admin/center/config/languages'

export function getCenterCountryPage(params: CenterCountryPageParams) {
  return apiRequest<CenterPageResult<CenterCountryListItem>>({ method: 'GET', url: COUNTRIES_URL, params })
}

export function getCenterCountryOptions() {
  return apiRequest<CenterCountryOption[]>({ method: 'GET', url: `${COUNTRIES_URL}/options` })
}

export function getCenterTimezoneOptions() {
  return apiRequest<CenterTimezoneOption[]>({ method: 'GET', url: `${COUNTRIES_URL}/timezone-options` })
}

export function createCenterCountry(data: CenterCountrySaveRequest) {
  return apiRequest<CenterCountryDetail>({ method: 'POST', url: COUNTRIES_URL, data })
}

export function updateCenterCountryImage(countryId: CenterId, data: CenterCountryImageUpdateRequest) {
  return apiRequest<void>({ method: 'PUT', url: `${COUNTRIES_URL}/${countryId}`, data })
}

export function getCenterCurrencyPage(params: CenterCurrencyPageParams) {
  return apiRequest<CenterPageResult<CenterCurrencyListItem>>({ method: 'GET', url: CURRENCIES_URL, params })
}

export function getCenterCurrencyOptions() {
  return apiRequest<CenterCurrencyOption[]>({ method: 'GET', url: `${CURRENCIES_URL}/options` })
}

export function getCenterCurrencyDetail(currencyId: CenterId) {
  return apiRequest<CenterCurrencyDetail>({ method: 'GET', url: `${CURRENCIES_URL}/${currencyId}` })
}

export function createCenterCurrency(data: CenterCurrencySaveRequest) {
  return apiRequest<CenterCurrencyDetail>({ method: 'POST', url: CURRENCIES_URL, data })
}

export function updateCenterCurrency(currencyId: CenterId, data: CenterCurrencySaveRequest) {
  return apiRequest<void>({ method: 'PUT', url: `${CURRENCIES_URL}/${currencyId}`, data })
}

export function getCenterExchangeRatePage(params: CenterExchangeRatePageParams) {
  return apiRequest<CenterPageResult<CenterExchangeRateListItem>>({ method: 'GET', url: EXCHANGE_RATES_URL, params })
}

export function getCenterExchangeRateDetail(exchangeRateId: CenterId) {
  return apiRequest<CenterExchangeRateDetail>({ method: 'GET', url: `${EXCHANGE_RATES_URL}/${exchangeRateId}` })
}

export function createCenterExchangeRate(data: CenterExchangeRateSaveRequest) {
  return apiRequest<CenterExchangeRateDetail>({ method: 'POST', url: EXCHANGE_RATES_URL, data })
}

export function updateCenterExchangeRate(exchangeRateId: CenterId, data: CenterExchangeRateSaveRequest) {
  return apiRequest<void>({ method: 'PUT', url: `${EXCHANGE_RATES_URL}/${exchangeRateId}`, data })
}

export function getCenterLanguagePage(params: CenterLanguagePageParams) {
  return apiRequest<CenterPageResult<CenterLanguageListItem>>({ method: 'GET', url: LANGUAGES_URL, params })
}

export function getCenterLanguageOptions() {
  return apiRequest<CenterLanguageOption[]>({ method: 'GET', url: `${LANGUAGES_URL}/options` })
}

export function getCenterLanguageDetail(languageId: CenterId) {
  return apiRequest<CenterLanguageDetail>({ method: 'GET', url: `${LANGUAGES_URL}/${languageId}` })
}

export function createCenterLanguage(data: CenterLanguageSaveRequest) {
  return apiRequest<CenterLanguageDetail>({ method: 'POST', url: LANGUAGES_URL, data })
}

export function reimportCenterLanguage(languageId: CenterId) {
  return apiRequest<CenterLanguageDetail>({ method: 'POST', url: `${LANGUAGES_URL}/${languageId}/reimport` })
}
